module.exports = __webpack_public_path__ + "static/media/navDocActive.a851b125.svg";